import { Controller } from "stimulus"

// Tooltips for content added after page load, set up like the page-wide ones
// in bootstrap-fixes.js: hover only, and none on touch screens.
export default class extends Controller {
  connect() {
    if (this.isTouchDevice()) return
    this.initializeTooltips();
  }

  initializeTooltips() {
    // Remove stray tooltip elements from DOM
    document.querySelectorAll(".tooltip").forEach(el => el.remove());

    // Bootstrap 4 tooltip initialization
    $(this.element).find('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
  }

  isTouchDevice() {
    return "ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch)
  }
}
